import { Typography } from "@mui/material";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

type ConfirmationModalPropsPick = Pick<
  ConfirmationModalProps,
  "loading" | "open" | "onClose" | "onConfirm"
>;

interface LeaveConfirmationModalProps extends ConfirmationModalPropsPick {
  context?: "team" | "workspace";
}

const LeaveConfirmationModal = ({
  context = "team",
  ...props
}: LeaveConfirmationModalProps) => (
  <ConfirmationModal
    title={context === "team" ? "Leave Team?" : "Leave Workspace?"}
    confirmProps={{ label: "Leave", type: "negative" }}
    {...props}
  >
    <Typography>
      {context === "team"
        ? "This action is permanent, and you will no longer be able to view data associated with this Team."
        : "Leaving this Workspace cannot be a undone. You will lose access to the Workspace and all associated data."}
    </Typography>
  </ConfirmationModal>
);

export default LeaveConfirmationModal;
